import { render, staticRenderFns } from "./Directors.vue?vue&type=template&id=35fd9627&scoped=true&"
import script from "./Directors.vue?vue&type=script&lang=js&"
export * from "./Directors.vue?vue&type=script&lang=js&"
import style0 from "./Directors.vue?vue&type=style&index=0&id=35fd9627&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd9627",
  null
  
)

export default component.exports